<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh">
    <li class="nav-item" :class="{'active': isActiveLink(path)}">
      <router-link class="nav-link" :to="path" v-if="path">{{ label }} <i :class="[classIcon]" v-if="classIcon"></i>
      </router-link>
      <div v-else class="nav-link" @click="$emit('onClick')">{{ label }} <i :class="[classIcon]" v-if="classIcon"></i>
      </div>
    </li>
  </div>
</template>
<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "menu-item",
  mixins: [checkPermissions],
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    classIcon: {
      type: String,
      default: null
    }
  },
  methods: {
    isActiveLink(path) {
      if (this.$route.path === path) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>
